/**
 * 用户工具类
 * @fader
 */

const userUtil = {

    getUserInfo(){
        let user_json = localStorage.getItem('userinfo');
        let userInfo = JSON.parse(user_json);
        return userInfo;
    }

}

export default userUtil